import { ReactElement } from 'react';
import { Typography } from '@getgo/chameleon-web-react-wrapper/register';
import { useTranslation } from 'react-i18next';
import styles from './NullValueCellRenderer.module.scss';

function NullValueCellRenderer(): ReactElement {
  const { t } = useTranslation();
  return (
    <div className={styles.cell}>
      <Typography variant="body-small">{t(`deviceDetails.grid.windows.nullValue`)}</Typography>
    </div>
  );
}

export default NullValueCellRenderer;
